import { useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';

import { streamActions, streamSelectors } from '../store/modules/stream';

const useFetchGuestsDestinations = (canFetch: boolean, streamId?: string) => {
  const dispatch = useDispatch();
  const params = useSelector(streamSelectors.selectGuestDestinationsParams);

  const isFetched = params && params === streamId;

  useEffect(() => {
    streamId && canFetch && !isFetched && dispatch(streamActions.fetchGuestsDestinations(streamId));
  }, [canFetch]);
};

export default useFetchGuestsDestinations;
